<template>
  <div class="spot-example-area">
    <div class="inner">
      <SpotExampleBarTip
        v-for="(item, index) in spotExList"
        :key="index"
        :img="item.img"
        :text="item.text"
        :selected="checkSelected(item.text)"
        @click-image="onSelect"
      />
    </div>
  </div>
</template>

<script>
import SpotExampleBarTip from "./SpotExampleBarTip";
import { SPOT_EX_LIST } from "../../const.js";

export default {
  name: "spot-example-bar",
  components: {
    SpotExampleBarTip,
  },
  computed: {
    spotExList() {
      return SPOT_EX_LIST;
    },
  },
  props: {
    selectedSpot: { type: String },
  },
  methods: {
    onSelect(text) {
      this.$emit("select-spot", text);
    },
    checkSelected(input) {
      return input === this.selectedSpot;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.spot-example-area {
  position: absolute;
  overflow: scroll;
  width: 100vw;
  z-index: 1;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.inner {
  display: flex;
  padding: 0.25rem;
  gap: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelect/SpotExampleBar.vue